import {Injectable} from '@angular/core';
import {BehaviorSubject} from 'rxjs';
import {map} from 'rxjs/operators';
import {HttpUtils} from '../http-utils';
import {URL_BASE} from '../../core/constants';
import {HttpClient} from '@angular/common/http';


@Injectable({providedIn: 'root'})
export class FeatureService {

  public features = new BehaviorSubject<Record<FEATURES, boolean>>(this.getInitialFeatureStatus());

  constructor(private http: HttpClient) {
    this.refreshFeaturesStatus();
  }

  public refreshFeaturesStatus() {
    this.getFeaturesStatus().subscribe(featuresStatus => this.features.next(featuresStatus));
  }

  public getFeatureStatus(feature: FEATURES) {
    return this.features.value[feature];
  }

  public getFeatureStatusObservable(feature: FEATURES) {
    return this.features.asObservable().pipe(map(features => features[feature]));
  }

  private getInitialFeatureStatus() {
    const alLFeaturesStatus = Object.keys(FEATURES).map(key => ([key, false]));
    return Object.fromEntries(alLFeaturesStatus);
  }

  public getFeaturesStatus() {
    const headers = HttpUtils.createHeadersWithoutAuthorization();
    const url = `${URL_BASE}/api/features`;
    return this.http.get<Record<string, string>>(url, {headers})
      .pipe(
        map(this.featureStatusFromDto)
      );
  }

  private featureStatusFromDto(featuresStatus: Record<string, string>) {
    return Object.fromEntries(Object.entries(featuresStatus).map(featureStatus => [FEATURES[featureStatus[0]], featureStatus[1]]));
  }
}

export enum FEATURES {
  BLUECHAT = 'BLUECHAT',
  CARRIER_MULTIPLE_VENDOR_NUMBERS = 'CARRIER_MULTIPLE_VENDOR_NUMBERS'
}
